<template>
  <footer class="rodape">
    <div class="linha-top">
      <!-- INFORMAÇÕES PARA TESTE -->
      <template v-if="Object.keys(this.$store.state.token).length >= 1">
        <div v-if="[ 'l', 'lv' ].indexOf($store.state.token.clu_con) === -1" class="info-teste">
          <div class="quadro">
            <template v-if="$store.state.token.contador === false">
              <a @click="appRodapeAbrirIniciante">Dicas Iniciais!</a>
            </template>
            <template v-else>
              <a href='http://www.rotinafacil.com.br' target='_blank'><img src="/img/rotina_facil.png"></a>
            </template>
          </div>
        </div>

        <!-- INDICAÇÃO -->
        <div v-else class="indicacao">
          <div>
            <span class="destaque">Indique</span>
              o RF e 
            <span class="destaque">ganhe <span style="font-family: arial;">R$ 45</span></span>
              em créditos!
          </div>

          <table class="campos">
            <tr>  
              <td>
                <input type="text" v-model="nome" placeholder="Nome da sua indicação" />
              </td>
              <td>
                <a href="https://s3-sa-east-1.amazonaws.com/arq.rotinafacil.com/termos/reg-indicacao/2020-12-16_reg-indicacao.pdf" target="_blank">leia o regulamento</a>
              </td>
            </tr>
            <tr>  
              <td>
                <input type="email" v-model="email" placeholder="E-mail da sua indicação" />
              </td>
              <td class="buttons">
                <button class="btn btn-sm btn-default" @click="appRodapeFormularioEnviar" :disabled="statusBt !== false">
                  <template v-if="statusBt === false">
                    Indicar
                  </template>
                  <template v-else>
                    Carregando...
                  </template>
                </button>
              </td>
            </tr>
          </table>
        </div>
      </template>

      <!-- PACOTES -->
      <div @click="appRodapeAbirPacotes" class="pacotes" v-if="Object.keys(this.$store.state.token).length >= 1">
        <div class="destaque">
          Experimente outros pacotes
        </div>
        <div class="destaque">
          <i class="fa fa-box-open"></i>
        </div>
      </div>

      <!-- SUPORTE -->
      <div class="suporte">
        <a href="https://web.whatsapp.com/send?phone=554130767488" target="_blank">
          <div>
            Atendimento 41 3076-7488
            <i class="fab fa-whatsapp"></i>
          </div>

          <div>
            8h30 às 12h e 13h30 às 18h
          </div>

          <div>
            Segunda à Sexta-Feira
          </div>
        </a>
      </div>
    </div>

    <div class="linha-bottom">
      <a href="http://www.rotinafacil.com.br" target="_blank">
        &copy; {{ appRodapePegarAnoAtual }} - Rotina Fácil - Subase Sistemas Estratégicos
      </a> - <router-link :to="{ name: 'termos' }" target="_blank">
        Termos de Uso
      </router-link> - <router-link :to="{ name: 'politica' }" target="_blank">
        Política de Privacidade
      </router-link> - <a @click="appRodapeAbrirIniciante">
        Dicas Iniciais
      </a>
    </div>
  </footer>
</template>

<style scoped>
  .destaque {
    color: #ffff33;
  }
  :not(.quadro) > a,
  :not(.quadro) > a:hover {
    color: #FFF !important;
    text-decoration: none !important;
    cursor: pointer !important;
  }

  .quadro > a {
    color: #444;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    opacity: 0.85;
  }

  .rodape {
    /* position: absolute;
    bottom: 0px;
    width: 100%; */
    background: url('./img/bg_pontilhado.gif');
    font-family: Arial;
    font-size: 13px;
    color: #FFF;
  }
  .rodape > .linha-top {
    padding-top: 10px;
    background: url('./img/sombra.png') no-repeat top center;
  }
  .rodape > .linha-top,
  .rodape > .linha-bottom {
    text-align: center;
    padding: 10px 0px;
  }
  .rodape > .linha-top > div  {
    display: inline-block;
    flex: 1;
  }
  .rodape > .linha-bottom > a:hover {
    text-decoration: underline !important;
  }
  
  /* SETA O TAMANHO PARA TRES COLUNAS */
  .rodape > .linha-top > div {
    width: calc(100% / 3);
    vertical-align: middle;
  }
    .rodape > .linha-top > .info-teste {
      font-size: 12px;
    }
      .rodape > .linha-top > .info-teste > .quadro {
        -moz-box-shadow: inset 0px 1px 0px 0px #ffffff;
        -webkit-box-shadow: inset 0px 1px 0px 0px #ffffff;
        box-shadow: inset 0px 1px 0px 0px #ffffff;

        background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #fafbec), color-stop(1, #f4f4d6) );
        background: -moz-linear-gradient( center top, #fafbec 5%, #f4f4d6 100% );
        filter: progid: DXImageTransform.Microsoft.gradient(startColorstr='#fafbec', endColorstr='#f4f4d6');
        background-color: #fafbec;

        -moz-border-radius: 6px;
        -webkit-border-radius: 6px;
        border-radius: 6px;

        border: 1px solid #c6c4c4;
        color: #000000;
        padding: 10px;
        line-height: 58px;
        vertical-align: middle;
        max-width: 300px;
        margin: 0px auto;
        text-decoration: none;
      }
      .rodape > .linha-top > .info-teste > .quadro > a > img {
        height: 55px;
      }
    .rodape > .linha-top > .indicacao > div {
      font-size: 15px;
    }
      .rodape > .linha-top > .indicacao > div > .destaque {
        font-weight: bold;
      }
    .rodape > .linha-top > .indicacao > table {
      width: 100%;
      max-width: 300px;
      margin: 0px auto;
    }
      .rodape > .linha-top > .indicacao > table > tr > td > input {
        width: 100%;
        margin: 2px 0px;
        padding: 4px 6px;
        border-radius: 3px;
        font-size: 11px;
        color: #555555;
        background-color: #ffffff;
        border: 1px solid #cccccc;
        -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        -moz-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        -webkit-transition: border linear .2s, box-shadow linear .2s;
        -moz-transition: border linear .2s, box-shadow linear .2s;
        -o-transition: border linear .2s, box-shadow linear .2s;
        transition: border linear .2s, box-shadow linear .2s;
      }
      .rodape > .linha-top > .indicacao > table > tr > td > button {
        width: 107px;
        padding: 3px 0px;
        color: #333;
        background-color: #fff;
        border-color: #ccc;
      }
    .rodape > .linha-top > .pacotes {
      font-weight: bold;
      color: #ffff33;
      cursor: pointer;
    }
      .rodape > .linha-top > .pacotes > div {
        padding: 8px 0px
      }
      .rodape > .linha-top > .pacotes > div:first-child {
        font-size: 14px;
      }
        .rodape > .linha-top > .pacotes > div > svg {
          font-size: 30px;
        }

    .rodape > .linha-top > .suporte > a > div {
      padding: 6px 0px
    }
    .rodape > .linha-top > .suporte > a > div:first-child {
      font-weight: bold;
    }
      .rodape > .linha-top > .suporte > a > div > svg {
        font-size: 14px;
        margin-left: 2px;
        vertical-align: -1px;
      }

  .rodape > .linha-bottom {
    border-top: 1px solid hsla(0,0%,100%,.3);
    -webkit-box-shadow: 1px -1px 2px rgba(0,0,0,.3);
    box-shadow: 1px -1px 2px rgba(0,0,0,.3);
  }

@media only screen and (max-width: 875px) {
  .rodape > .linha-top > .info-teste,
  .rodape > .linha-top > .indicacao {
    display: none;
  }
  .rodape > .linha-top > div {
    width: calc(100% / 2);
  }
}
</style>

<style>
</style>

<script>
  export default {
    data: function () {
      return {
        time: null,
        // formulario: {},
        nome: '',
        email: '',
        statusBt: false,
        tamamnhoTelaFuncao: ''
      }
    },
    mounted: function () {
      this.appRodapeIniciar()
    },
    // destroyed: function () {
    //   $('.info-teste').qtip('destroy')
    // },
    methods: {
      appRodapeIniciar: function () {
        // this.appRodapeMontarQtip()
      },
      // appRodapeMontarQtip: function () {
      //   // REMOVE O QTIP DO CAMPO ANTERIOR
      //   $('.info-teste').qtip('destroy')

      //   // VERIFICA SE O CAMPO VAI EXISTIR
      //   if (Object.keys(this.$store.state.token).length >= 1 && [ 'l', 'lv' ].indexOf(this.$store.state.token.clu_con) === -1 && this.$store.state.token.contador === false) {
      //     // INICIA A MONTAGEM DO CAMPO
      //     var mensagem = ''
  
      //     // VERIFICA SE TEM O PACOTE DE NFC-E OU NFE
      //     if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 20, 23, 25 ], 'or', null, null, null, null, false) === true) {
      //       mensagem += 'A emissão de documentos fiscais se da apenas no ambiente de homologação da SEFAZ, portanto não tem validade fiscal. Basta contratar o Rotina Fácil e já poderá emitir seus documentos fiscais no ambiente de Produção.<br/><br/>'
      //     }
  
      //     // VERIFICA SE TEM O PACOTE E-MAIL MARKETING
      //     if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 3 ], null, null, null, null, null, false) === true) {
      //       mensagem += 'Neste período de testes você deve informar um e-mail para disparar uma campanha. Informe clicando em <u>Configurações -> Contas de E-mail -> Novo E-mail</u>. Após a contratação, colocaremos nosso e-mail disparador!<br/><br/>'
      //     }
  
      //     // SETA A MENSAGEM DO ATENDIMENTO
      //     mensagem += 'Oferecemos o CHAT para tirar todas as suas dúvidas e auxiliar neste período inicial.<br/><br/>Para contratar-nos basta clicar em Configurações -> Meu Cadastro e fazer o aceite do contrato de licença de uso ou entre em contato conosco!'
          
      //     // ADICIONA O QTIP NO CAMPO
      //     $('.info-teste').qtip({
      //       content: {
      //         text: mensagem
      //       },
      //       position: {
      //         my: 'bottom center',
      //         at: 'top center'
      //       },
      //       style: {
      //         classes: 'qtip2-pdr qtip-blue qtip-rounded qtip-shadow'
      //       }
      //     })

      //     // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      //     this.time = new Date().getTime()
      //   }
      // },
      appRodapeFormularioEnviar: function () {
        // SETA O STATUS DE CARREGANDO PARA O BOTÃO
        this.statusBt = true

        // INICIA A VARIAVEL DE ERRO
        var erros = []

        // FAZ A VALIDAÇÃO DO CAMPO
        if ([ '', null, undefined ].indexOf(this.nome) !== -1 || this.nome.length <= 3) {
          erros.push('É necessario informar seu nome completo.')
        }

        // SETA O REGEX PARA VALIDAR O E-MAIL
        // eslint-disable-next-line
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        // SETA A VALIDAÇÃO DO E-MAIL
        if ([ '', null, undefined ].indexOf(this.email) !== -1 || regex.test(String(this.email).toLowerCase()) === false) {
          erros.push('É necessario informar um e-mail válido.')
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE COMUNICAR COM A API
        if (erros.length === 0) {
          // INICIA O FORMULARIO
          var formData = {}

          // SETA O CAMPO NOME
          formData.nome = this.nome

          // SETA O CAMPO EMAIL
          formData.email = this.email

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/subase/indica', 'POST', formData, (apiSuccess) => {
            // APRESENTA A MENSAGEM RECEBIDA
            this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.statusBt = false
          }, (apiError) => {
            // APRESENTA A MENSAGEM RECEBIDA
            this.$store.state.TRATAR_RET_LOT_API(apiError)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, (apiValid) => {
            // APRESENTA A MENSAGEM RECEBIDA
            this.$store.state.TRATAR_RET_LOT_API(apiValid)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA A MENSAGEM RECEBIDA NO VETOR
          for (var indexE in erros) {
            this.$store.state.msgWarn('WEB [409]: ' + erros[indexE], 'danger')
          }

          // LIBERA O STATUS DO BOTAÃO
          this.statusBt = false

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      appRodapeAbirPacotes: function () {
        // SETA OS PARAMETROS PARA INICIAR
        var params = { tipo: 'DETALHES_LU', pagina: 'pacotes' }

        // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },
      appRodapeAbrirIniciante: function () {
        // MANDA PARA TELA SOLICITADA
        this.$router.push({ name: 'iniciante' })

        // REDIRECIONA A TELA PARA O TOP
        window.scrollTo(0, 0)
      }
    },
    computed: {
      appRodapePegarAnoAtual: function () {
        // INICIA A VARIAVEL
        var ano = '2023'

        // VERIFICA SE TEM DATA SALVA
        if ([ '', null, undefined ].indexOf(this.$store.state.dadosApi) === -1 && [ '', null, undefined ].indexOf(this.$store.state.dadosApi.dataAtual) === -1) {
          // IMPORTA BIBLIOTECA DEPENDENTE
          var moment = require('moment')

          // PEGA A DATA ATUAL
          var dataAtual = moment(this.$store.state.dadosApi.dataAtual, 'DD/MM/YYYY')
  
          // PEGA O ANO
          ano = dataAtual.format('YYYY')
        }

        // RETORNA O ANO DO SERVIDOR
        return ano
      }
    }
  }
</script>
